import { render, staticRenderFns } from "./manageExceptions.vue?vue&type=template&id=3ed1c72f&scoped=true"
import script from "./manageExceptions.vue?vue&type=script&lang=js"
export * from "./manageExceptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed1c72f",
  null
  
)

export default component.exports